import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { superAdminAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Lock, Eye, EyeOff, CheckCircle } from 'lucide-react';

export default function FirstLogin() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [form, setForm] = useState({ new_password: '', confirm: '' });
  const [show, setShow] = useState({ new_password: false, confirm: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.new_password.length < 8) {
      setError('Password minimal 8 karakter');
      return;
    }
    if (form.new_password !== form.confirm) {
      setError('Konfirmasi password tidak cocok');
      return;
    }
    setLoading(true);
    try {
      await superAdminAPI.changeFirstPassword({ new_password: form.new_password });
      setSuccess(true);
      setTimeout(() => navigate('/dashboard'), 2000);
    } catch (e) {
      setError(e.response?.data?.detail || 'Gagal memperbarui password. Coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0f7f3 0%, #e8f5ee 100%)', padding: 20,
    }}>
      <div style={{
        background: '#fff', borderRadius: 20, padding: '48px 40px', width: '100%', maxWidth: 440,
        boxShadow: '0 8px 40px rgba(26,87,51,0.10)', border: '1px solid #e0ece5',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo-stockara.png" alt="Stockara" style={{ height: 40, marginBottom: 20 }} />
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#e8f5ee', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <Lock size={24} color="#1A5733" />
          </div>
          <h1 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: '#1a1a1a' }}>Buat Password Baru</h1>
          <p style={{ margin: 0, fontSize: 14, color: '#666', lineHeight: 1.5 }}>
            Halo{user?.name ? ` kak ${user.name}` : ''}! Sebelum mulai, buat password baru yang aman untuk akun kaka.
          </p>
        </div>

        {success ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <CheckCircle size={48} color="#4CAF50" style={{ margin: '0 auto 16px' }} />
            <p style={{ fontSize: 16, fontWeight: 600, color: '#1a1a1a', margin: '0 0 8px' }}>Password berhasil diperbarui!</p>
            <p style={{ fontSize: 14, color: '#666', margin: 0 }}>Mengarahkan ke dashboard...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{ padding: '10px 14px', background: '#fff3f3', border: '1px solid #ffcccc', borderRadius: 10, color: '#d32f2f', fontSize: 13, marginBottom: 20 }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 }}>
                Password Baru
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={show.new_password ? 'text' : 'password'}
                  value={form.new_password}
                  onChange={e => setForm(f => ({ ...f, new_password: e.target.value }))}
                  placeholder="Minimal 8 karakter"
                  required
                  style={{
                    width: '100%', padding: '12px 44px 12px 14px', border: '1px solid #e0e8e0',
                    borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box',
                    fontFamily: 'inherit',
                  }}
                />
                <button type="button" onClick={() => setShow(s => ({ ...s, new_password: !s.new_password }))}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', padding: 0 }}>
                  {show.new_password ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              {form.new_password.length > 0 && form.new_password.length < 8 && (
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#f57c00' }}>Masih kurang {8 - form.new_password.length} karakter</p>
              )}
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 }}>
                Konfirmasi Password
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={show.confirm ? 'text' : 'password'}
                  value={form.confirm}
                  onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
                  placeholder="Ulangi password baru"
                  required
                  style={{
                    width: '100%', padding: '12px 44px 12px 14px', border: '1px solid #e0e8e0',
                    borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box',
                    fontFamily: 'inherit',
                  }}
                />
                <button type="button" onClick={() => setShow(s => ({ ...s, confirm: !s.confirm }))}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', padding: 0 }}>
                  {show.confirm ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              {form.confirm.length > 0 && form.new_password !== form.confirm && (
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#d32f2f' }}>Password tidak cocok</p>
              )}
              {form.confirm.length > 0 && form.new_password === form.confirm && form.new_password.length >= 8 && (
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#4CAF50', display: 'flex', alignItems: 'center', gap: 4 }}>
                  <CheckCircle size={12} /> Password cocok
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading || form.new_password.length < 8 || form.new_password !== form.confirm}
              style={{
                width: '100%', padding: '14px', border: 'none', borderRadius: 10, cursor: 'pointer',
                background: (loading || form.new_password.length < 8 || form.new_password !== form.confirm) ? '#ccc' : '#1A5733',
                color: '#fff', fontSize: 15, fontWeight: 700, fontFamily: 'inherit',
                transition: 'background 0.2s',
              }}
            >
              {loading ? 'Menyimpan...' : 'Simpan Password Baru'}
            </button>

            <button
              type="button"
              onClick={() => { logout(); navigate('/login'); }}
              style={{ width: '100%', marginTop: 12, padding: '12px', border: '1px solid #e0e8e0', borderRadius: 10, cursor: 'pointer', background: '#fff', color: '#666', fontSize: 14, fontFamily: 'inherit' }}
            >
              Keluar
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
